export default function TrashIcon({ className, ...rest }) {
  // #475467
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M1 4.00016H2.33333M2.33333 4.00016H13M2.33333 4.00016V13.3335C2.33333 13.6871 2.47381 14.0263 2.72386 14.2763C2.97391 14.5264 3.31304 14.6668 3.66667 14.6668H10.3333C10.687 14.6668 11.0261 14.5264 11.2761 14.2763C11.5262 14.0263 11.6667 13.6871 11.6667 13.3335V4.00016H2.33333ZM4.33333 4.00016V2.66683C4.33333 2.31321 4.47381 1.97407 4.72386 1.72402C4.97391 1.47397 5.31304 1.3335 5.66667 1.3335H8.33333C8.68696 1.3335 9.02609 1.47397 9.27614 1.72402C9.52619 1.97407 9.66667 2.31321 9.66667 2.66683V4.00016M5.66667 7.3335V11.3335M8.33333 7.3335V11.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
